import * as React from 'react';
import { RichEditor as DesignRichEditor } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import { richEditorRegExp, controls } from '@utils/util';

const RichEditor = ({ element, elementStyle }) => {
  const { formSettings, formItemSettings, settings, className } = element.data;
  const { visible } = settings;
  const { rules = [] } = formSettings;

  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required, validator: (rule, value) => richEditorRegExp(rule, value, rules[0]) }]
  }
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
      {...ruleProps}
    >
      <DesignRichEditor
        style={elementStyle}
        controls={controls}
        className={className}
        {...formItemSettings}
      />
    </FormItem>
  );
};

export default RichEditor;
